<template>
    <div class="row margin-tb-50">

        <header class="header margin-b-25">

            <h1>Kortoplysninger</h1>

            <p>Angive dine kreditkort oplysninger, til betaling af din bestilling.</p>
            <p><strong>BEMÆRK, at der i bunden er angivet hvilke kort, der kan benyttes.</strong></p>

        </header>

        <div class="col-12 margin-b-25">

            <label>Hvad er dit kortnummer?</label>

            <div class="input-group">

                <div id="card-number" class="input" :class="{'in-focus':cardNumberInFocus}"></div>

                <span class="card-type" v-if="cardNumberValidated">

                    <img :src="cardType" v-if="cardType">

                </span>

                <span class="checkmark" v-if="!cardNumberValidated && hasEnteredCardNumber">

                    <i class="icon--md icon--red fas fa-check-circle"></i>

                </span>

            </div>

        </div>

        <div class="col-12 margin-b-25">

            <div class="grid-row">

                <section class="col-7">

                    <label>Hvilke måned / år udløber dit kort?</label>

                    <div class="input-group col-12 margin-b-25">

                        <div id="card-expiry" class="input" :class="{'in-focus':cardExpiryInFocus}"></div>

                        <span class="checkmark" v-if="expirationValidated">

                            <i class="icon--md icon--green fas fa-check-circle"></i>

                        </span>

                        <span class="checkmark" v-if="!expirationValidated && hasEnteredExpiry">

                            <i class="icon--md icon--red fas fa-check-circle"></i>

                        </span>

                    </div>

                </section>

                <section class="col-5 margin-b-25">

                    <label>Hvad er dine kontrolcifre?</label>

                    <div class="input-group">

                        <div id="card-cvc" class="input" :class="{'in-focus':cardCvcInFocus}"></div>

                        <span class="checkmark" v-if="cvcValidated">

                            <i class="icon--md icon--green fas fa-check-circle"></i>

                        </span>

                        <span class="checkmark" v-if="!cvcValidated && hasEnteredCvc">

                            <i class="icon--md icon--red fas fa-check-circle"></i>

                        </span>

                    </div>

                </section>

            </div>

            <section class="col-12">

                <div class="card-list">

                    <img src="/images/visa-icon.svg" alt="Visa"/>
                    <img src="/images/mastercard-icon.svg" alt="Mastercard"/>
                    <img src="/images/american-express-icon.svg" alt="American Express"/>

                    <a class="payment" tabindex="-1" title="Besøg Stripe" target="_blank" href="https://stripe.com/dk"><img src="/images/stripe-logo.svg" alt="Stripe Logo"></a>

                </div>

            </section>

            <section class="col-12 margin-t-25">

                <p><strong>OBS!</strong> Vi modtager <strong>IKKE alm. Dankort</strong> i shoppen.</p>

            </section>

        </div>

    </div>
</template>

<script>
    var stripe = Stripe(stripeKey);
    var elements = stripe.elements();
    import {mapGetters} from 'vuex';
    export default {
        name: "stripeForm",
        data(){
            return {
                cardNumber: null,
                cardExpiry: null,
                cvc: null,
                cardImages: {
                    visa: '/images/visa-icon.svg',
                    mastercard: '/images/mastercard-icon.svg',
                    discover: '/images/discover-icon.svg',
                    jcb: '/images/jcb-icon.svg',
                    dinersclub: '/images/diners-club-icon.svg',
                    amex: '/images/american-express-icon.svg',
                },
                cardNumberInFocus: false,
                cardNumberValidated: false,
                currentCard: '',
                cardExpiryInFocus: false,
                expirationValidated: false,
                cardCvcInFocus: false,
                cvcValidated: false,
                isLoading: false,
                enteredFields: [],
            }
        },
        computed:{
            ...mapGetters(['order']),
            information(){
                return this.order.information;
            },
            cardType() {
                return (this.currentCard != 'unknown' && this.currentCard != '') ? this.cardImages[this.currentCard] : false;
            },
            hasEnteredCardNumber() {
                return this.fieldHasBeenEntered('card-number');
            },
            hasEnteredExpiry() {
                return this.fieldHasBeenEntered('expiry');
            },
            hasEnteredCvc() {
                return this.fieldHasBeenEntered('cvc');

            }
        },
        methods:{
            requestCardToken() {
                this.isLoading = true;
                /* stripe.createToken(this.cardNumber, {
                     name: `${this.information.firstname} ${this.information.lastname}`,
                     address_line1: this.information.address,
                     address_city: this.city,
                     address_zip: this.information.zipcode,
                     address_country: 'DK'
                 }).then((result) => {
                     if (result.hasOwnProperty('error')){
                         return this.stripeFailedResponse(result);
                     }
                     this.stripeSuccesfulResponse(result.token);
                 }).catch((error) => {
                     this.stripeFailedResponse(error);
                 });*/

                stripe.createPaymentMethod('card', this.cardNumber, {
                    'billing_details':{
                        name: `${this.information.firstname} ${this.information.lastname}`,
                        email: `${this.information.email}`,
                        phone: `${this.information.phone}`,
                        address:{
                            line1: this.information.address,
                            city: this.city,
                            postal_code: this.information.zipcode,
                            country: 'DK'
                        }
                    }
                }).then((result) => {
                    if (result.error){
                        return this.stripeFailedResponse(result);
                    }
                    this.stripeSuccesfulResponse(result.token);
                });


            },
            stripeSuccesfulResponse(response) {
                this.$store.dispatch('setToken', response);
                this.$store.dispatch('completedInformation');
                this.$router.push({
                    name:'order.delivery'
                });
                this.unmountFields();
                this.isLoading = false;
            },
            stripeFailedResponse(response) {
                this.isLoading = false;
                this.$router.replace({
                    name:'order.card.failed'
                });
            },
            unmountFields(){
                this.cardNumber.unmount('#card-number');
                this.cardNumber.removeEventListener('change');
                this.cardExpiry.unmount('#card-expiry');
                this.cardExpiry.removeEventListener('change');
                this.cardCvc.unmount('#card-cvc');
                this.cardCvc.removeEventListener('change');

                this.cardNumber = null;
                this.cardExpiry = null;
                this.cardCvc = null;
            },
            fieldHasBeenEntered(fieldName) {
                return this.enteredFields.indexOf(fieldName) > -1
            },
            enteredField(fieldName) {
                if (!this.fieldHasBeenEntered(fieldName)) {
                    return this.enteredFields.push(fieldName);
                }
            },
        },
        mounted() {
            console.log('mounted');
            elements = stripe.elements();
            if (this.information.city) {
                this.city = this.information.city;
            }

            let base = {
                fontFamily: "'Work Sans', sans-serif",
                fontSize: '16px',
                fontWeight: '300',
                color: '#4a4847',
                '::placeholder': {
                    color: "#bcb9b8",
                }
            };

            this.cardNumber = elements.create('cardNumber', {
                style: {
                    base,
                },
                placeholder: 'f.eks. 9988 7733 8877 8822'
            });
            this.cardNumber.mount('#card-number');
            this.cardNumber.on('focus', (e) => {
                this.cardNumberInFocus = true;
            });
            this.cardNumber.addEventListener('change', (e) => {
                if (e.error) {
                    this.cardNumberValidated = false;
                } else {
                    if (e.complete && e.brand != 'unknown') {
                        this.cardNumberValidated = true;
                    } else {
                        this.cardNumberValidated = false;
                    }
                }
                this.currentCard = e.brand;
            });
            this.cardNumber.on('blur', (e) => {
                this.enteredField('card-number');
                this.cardNumberInFocus = false;
            });


            this.cardExpiry = elements.create('cardExpiry', {
                style: {
                    base,
                },
                placeholder: 'MM / ÅÅ',
            });
            this.cardExpiry.mount('#card-expiry');
            this.cardExpiry.on('focus', (e) => {
                this.cardExpiryInFocus = true;
            });
            this.cardExpiry.on('blur', (e) => {
                this.enteredField('expiry');
                this.cardExpiryInFocus = false;
            });
            this.cardExpiry.addEventListener('change', (e) => {
                if (e.error) {
                    this.expirationValidated = false;
                } else {
                    if (e.complete) {
                        this.expirationValidated = true;
                    } else {
                        this.expirationValidated = false;
                    }
                }
            });

            this.cardCvc = elements.create('cardCvc', {
                style: {
                    base,
                },
                placeholder: 'f.eks. 123',
            });
            this.cardCvc.mount('#card-cvc');
            this.cardCvc.on('focus', (e) => {
                this.cardCvcInFocus = true;
            });
            this.cardCvc.on('blur', (e) => {
                this.enteredField('cvc');
                this.cardCvcInFocus = false;
            });
            this.cardCvc.addEventListener('change', (e) => {
                if (e.error) {
                    this.cvcValidated = false;
                } else {
                    if (e.complete) {
                        this.cvcValidated = true;
                    } else {
                        this.cvcValidated = false;
                    }
                }
            });
        },
    }
</script>

<style scoped>

</style>
